import { useMemo } from 'react';
import PropTypes from 'prop-types';
import DetailsGrid from '@/common-utils/components/renders/detailsGrid/DetailsGrid';
import MoneticConfigurationView from './MoneticConfigurationView';
import payluddTerminalStateFields from '../fields/payluddTerminalStateFields';
import { buildPayluddMpfFlatData } from '../utils/buildPayluddTerminalStateDisplay';

const PAYLUDD_SOFTWARE_FIELDS = {
    applicationVersion: payluddTerminalStateFields.PAYLUDD.APPLICATION_VERSION,
    payluddVersion: payluddTerminalStateFields.PAYLUDD.PAYLUDD_VERSION,
    androidVersion: payluddTerminalStateFields.PAYLUDD.ANDROID_VERSION,
    firmware: payluddTerminalStateFields.PAYLUDD.FIRMWARE
};

const PAYLUDD_MPF_FIELDS = {
    payluddMpfMode: payluddTerminalStateFields.PAYLUDD_MPF_DISPLAY.MODE,
    payluddMpfPaymentReceiptKeys: payluddTerminalStateFields.PAYLUDD_MPF_DISPLAY.PAYMENT_TICKETS,
    payluddMpfAdditionalServiceKeys: payluddTerminalStateFields.PAYLUDD_MPF_DISPLAY.ADDITIONAL_SERVICES,
    payluddMpfBurgerMenuLock: payluddTerminalStateFields.PAYLUDD_MPF_DISPLAY.BURGER_MENU_LOCK
};

const PAYLUDD_INIT_FIELDS = {
    initializationStatus: payluddTerminalStateFields.PAYLUDD.INITIALIZATION_STATUS,
    packageCode: payluddTerminalStateFields.PAYLUDD.PACKAGE_CODE,
    packageLabel: payluddTerminalStateFields.PAYLUDD.PACKAGE_LABEL,
    initializationDate: payluddTerminalStateFields.PAYLUDD.INITIALIZATION_DATE,
    lastUpdate: payluddTerminalStateFields.PAYLUDD.POS_TERMINAL_STATE_DATE
};

/**
 * Payludd terminal state details: software / MPF / init grids + monetic configuration.
 * @param {object} root0
 * @param {object} [root0.posTerminal]
 * @returns {JSX.Element}
 */
function PayluddPosTerminalDetails({ posTerminal }) {
    const payluddMpfGridData = useMemo(() => buildPayluddMpfFlatData(posTerminal), [posTerminal]);
    const beneficiaries = posTerminal?.payludd?.paymentConfiguration?.beneficiaries ?? [];

    return (
        <div className='space-y-4'>
            {posTerminal &&
                <div className='grid grid-cols-1 lg:grid-cols-3 gap-x-8 gap-y-4'>
                    <div className='min-w-0'>
                        <DetailsGrid data={posTerminal} fields={PAYLUDD_SOFTWARE_FIELDS} singleColumnLayout />
                    </div>
                    <div className='min-w-0'>
                        <DetailsGrid data={payluddMpfGridData} fields={PAYLUDD_MPF_FIELDS} singleColumnLayout />
                    </div>
                    <div className='min-w-0'>
                        <DetailsGrid data={posTerminal} fields={PAYLUDD_INIT_FIELDS} singleColumnLayout />
                    </div>
                </div>}
            <MoneticConfigurationView beneficiaries={beneficiaries} />
        </div>
    );
}

PayluddPosTerminalDetails.propTypes = {
    posTerminal: PropTypes.object
};

export default PayluddPosTerminalDetails;
